import { GetServerSideProps } from "next";
import { ReactElement } from "react";
import { getPageProps } from "@services/initial-calls";
import TermsAndConditions from "@components/shared/legal/termsAndConditions";
import BestBabyFormulaLawyersWrapper from "@components/layouts/bestbabyformulalawyersWrapper";

export default function BestBabyFormulaLawyersHome(): ReactElement {
    return (
        <BestBabyFormulaLawyersWrapper>
            <div className="w-full max-w-7xl mx-auto">
                <TermsAndConditions
                    category="BabyFormula"
                    domain="BestBabyFormulaLawyers.com"
                />
            </div>
        </BestBabyFormulaLawyersWrapper>
    );
}

export const getServerSideProps: GetServerSideProps = async (context) => {
    return await getPageProps(context, "home", {
        pageTitle: "Terms And Conditions",
    });
};
